export default __webpack_public_path__ + "static/media/yourdevtools.7f481d4c.png";